import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { BsArrowLeft, BsArrowRight, BsInfoCircle } from 'react-icons/bs';

import modelo1 from 'assets/images/modelo_1.svg';
import modelo2 from 'assets/images/modelo_2.svg';
import modelo3 from 'assets/images/modelo_3.svg';

import {
  Buttons,
  CloseButton,
  Header,
  HeaderTexts,
  ModelField,
  ModelImage,
  ModelName,
  ModelText,
  NextButton,
  Overlay,
  Panel,
  PreviousButton,
  Tag,
  Text,
  Title,
} from './styles';

type Modelo = {
  nome: string;
  campo: string;
  imagem: string;
};

const MODELOS: Modelo[] = [
  { nome: 'Modelo 1', campo: 'Correntista', imagem: modelo1 },
  { nome: 'Modelo 2', campo: 'Cod.Cliente', imagem: modelo2 },
  { nome: 'Modelo 3', campo: 'Cod.Cliente', imagem: modelo3 },
];

const AVISO =
  'Caso você ainda não tenha recebido uma conta, entre em contato com seu consultor';

type ModalOndeEncontrarProps = {
  open: boolean;
  onClose: () => void;
};

const CloseIcon = (): JSX.Element => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M3 3L13 13M13 3L3 13"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const ModalOndeEncontrar = ({
  open,
  onClose,
}: ModalOndeEncontrarProps): JSX.Element | null => {
  const [indice, setIndice] = useState(0);

  if (!open) return null;

  const modelo = MODELOS[indice];
  const anterior = (): void => setIndice((atual) => Math.max(atual - 1, 0));
  const proximo = (): void =>
    setIndice((atual) => Math.min(atual + 1, MODELOS.length - 1));
  const primeiro = indice === 0;
  const ultimo = indice === MODELOS.length - 1;

  const conteudo = (
    <Overlay role="presentation" onClick={onClose}>
      <Panel
        role="dialog"
        aria-modal="true"
        aria-label="Onde posso encontrar meu código do cliente?"
        onClick={(event) => event.stopPropagation()}
      >
        <Header>
          <HeaderTexts>
            <Title>Onde posso encontrar meu código do cliente?</Title>
            <Text>
              Existem alguns modelos de Nota Fiscal verifique qual é a sua
            </Text>
          </HeaderTexts>
          <CloseButton type="button" aria-label="Fechar" onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        </Header>

        <ModelText>
          <ModelName>{modelo.nome}</ModelName>
          {' - Você pode encontrá-lo na seção '}
          <ModelField>Dados adicionais</ModelField>
          {' de sua nota fiscal no item '}
          <ModelField>{modelo.campo}</ModelField>
          <span>, como é exemplificado no exemplo abaixo:</span>
        </ModelText>

        <ModelImage
          src={modelo.imagem}
          alt={`${modelo.nome} de nota fiscal com o código do cliente destacado`}
        />

        <Tag>
          <BsInfoCircle aria-hidden="true" />
          {AVISO}
        </Tag>

        <Buttons>
          <PreviousButton type="button" disabled={primeiro} onClick={anterior}>
            <BsArrowLeft aria-hidden="true" />
            Anterior
          </PreviousButton>
          <NextButton type="button" disabled={ultimo} onClick={proximo}>
            Próximo
            <BsArrowRight aria-hidden="true" />
          </NextButton>
        </Buttons>
      </Panel>
    </Overlay>
  );

  if (typeof document === 'undefined') return conteudo;

  return createPortal(conteudo, document.body);
};

export default ModalOndeEncontrar;
